import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import {
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Entry2xmjmyutzoq3p as Entry,
} from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysClass;
function HashMapKeys() {
  if (HashMapKeysClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor(backing) {
        return new.target.k9(backing);
      }
      static k9(backing) {
        var $this = this.b8();
        $this.j9_1 = backing;
        return $this;
      }
      q2() {
        return this.j9_1.q2();
      }
      n1() {
        return this.j9_1.q2() === 0;
      }
      t2(element) {
        return this.j9_1.i9(element);
      }
      a5() {
        return this.j9_1.a5();
      }
      i2(element) {
        throw UnsupportedOperationException().j8();
      }
      u2(elements) {
        throw UnsupportedOperationException().j8();
      }
      p1() {
        return this.j9_1.p9();
      }
      o6() {
        return this.j9_1.q9();
      }
    }
    initMetadataForClass($, 'HashMapKeys', VOID, VOID, [KtMutableSet()]);
    HashMapKeysClass = $;
  }
  return HashMapKeysClass;
}
var HashMapValuesClass;
function HashMapValues() {
  if (HashMapValuesClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor(backing) {
        return new.target.m9(backing);
      }
      static m9(backing) {
        var $this = this.m6();
        $this.l9_1 = backing;
        return $this;
      }
      q2() {
        return this.l9_1.q2();
      }
      n1() {
        return this.l9_1.q2() === 0;
      }
      r9(element) {
        return this.l9_1.t4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.r9(element);
      }
      s9(element) {
        throw UnsupportedOperationException().j8();
      }
      i2(element) {
        return this.s9(element);
      }
      t9(elements) {
        throw UnsupportedOperationException().j8();
      }
      u2(elements) {
        return this.t9(elements);
      }
      p1() {
        return this.l9_1.u9();
      }
      o6() {
        return this.l9_1.q9();
      }
    }
    initMetadataForClass($, 'HashMapValues', VOID, VOID, [Collection(), MutableIterable()]);
    HashMapValuesClass = $;
  }
  return HashMapValuesClass;
}
var HashMapEntrySetClass;
function HashMapEntrySet() {
  if (HashMapEntrySetClass === VOID) {
    class $ extends HashMapEntrySetBase() {
      constructor(backing) {
        return new.target.o9(backing);
      }
      static o9(backing) {
        return this.w9(backing);
      }
      p1() {
        return this.v9_1.x9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySet');
    HashMapEntrySetClass = $;
  }
  return HashMapEntrySetClass;
}
var HashMapEntrySetBaseClass;
function HashMapEntrySetBase() {
  if (HashMapEntrySetBaseClass === VOID) {
    class $ extends AbstractMutableSet() {
      static w9(backing) {
        var $this = this.b8();
        $this.v9_1 = backing;
        return $this;
      }
      q2() {
        return this.v9_1.q2();
      }
      n1() {
        return this.v9_1.q2() === 0;
      }
      y9(element) {
        return this.v9_1.aa(element);
      }
      t2(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.y9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      a5() {
        return this.v9_1.a5();
      }
      z9(element) {
        throw UnsupportedOperationException().j8();
      }
      i2(element) {
        return this.z9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      u2(elements) {
        throw UnsupportedOperationException().j8();
      }
      q4(elements) {
        return this.v9_1.ba(elements);
      }
      o6() {
        return this.v9_1.q9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySetBase', VOID, VOID, [KtMutableSet()]);
    HashMapEntrySetBaseClass = $;
  }
  return HashMapEntrySetBaseClass;
}
//region block: exports
export {
  HashMapEntrySet as HashMapEntrySet29p2ksc4wcy5i,
  HashMapKeys as HashMapKeys28ggmxpft3hz9,
  HashMapValues as HashMapValues3umcxpfyfunqf,
};
//endregion

//# sourceMappingURL=HashMapEntry.mjs.map
